/** ApiError carries the backend's status and error code for typed handling. */
export class ApiError extends Error {
    status;
    code;
    /** The decoded error body (when the backend sent JSON), for codes that carry extra fields. */
    body;
    constructor(status, code, message, body = null) {
        super(message);
        this.name = "ApiError";
        this.status = status;
        this.code = code;
        this.body = body;
    }
    get isUnauthorized() {
        return this.status === 401;
    }
    get isValidation() {
        return this.code === "validation_error";
    }
}
/** User-facing message from bridge/API failures. */
export function errorMessage(err, fallback) {
    if (err instanceof ApiError || err instanceof Error)
        return err.message;
    return fallback;
}
/** Thrown by `login()` when the backend asks the user to pick a site (no tokens issued). */
export class SiteChoiceRequiredError extends ApiError {
    sites;
    constructor(sites) {
        super(300, "SITE_CHOICE_REQUIRED", "choose a site to sign in to");
        this.name = "SiteChoiceRequiredError";
        this.sites = sites;
    }
}
//# sourceMappingURL=errors.js.map